export const PAGE_SIZE = 8;
export const PAGE_SIZES = [8, 25, 50];
